import { render, staticRenderFns } from "./CommunicationPreferences.vue?vue&type=template&id=6aeedbea"
import script from "./CommunicationPreferences.vue?vue&type=script&lang=js"
export * from "./CommunicationPreferences.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports